import React, { type PropsWithChildren } from 'react';
import { View } from 'react-native';

import AuthErrorPage from '@/app/auth-error';
import { useSession } from '@/components/auth';

/**
 * Renders the app, and the "sign in again" prompt OVER it when the session is refused (#692).
 *
 * The root layout used to swap the whole tree for the auth-error screen, which unmounted every
 * open form, draft and composer — for what was usually a transient blip. Keeping the children
 * mounted means "Try again" can pick up exactly where the user was.
 */
export const AuthErrorHost = ({ children }: PropsWithChildren) => {
	const { authError } = useSession();
	return (
		<View style={{ flex: 1 }}>
			{children}
			{authError ? <AuthErrorPage variant="overlay" /> : null}
		</View>
	);
};
